import { PropsWithChildren } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Box, makeStyles } from '@material-ui/core';

import { HEADER_HEIGHT, Header } from './Header';
import { Step } from './Step';
import { StepTitle } from './StepTitle';
import { Stepper } from './Stepper';
import { StepperContext } from './StepperContext';

type TutorialWizardProps = PropsWithChildren<{
  title: string;
  onClose?: () => void;
}>;

const useStyles = makeStyles(theme => ({
  wizard: {
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    display: 'grid',
    gridTemplateRows: `${HEADER_HEIGHT}px 1fr`,
    gridTemplateColumns: '100%',
  },
  grid: {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: '100%',
    gridTemplateRows: 'max-content max-content 1fr',
    gridTemplateAreas: `
      "stepper"
      "docs"
      "step"
    `,
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    maxWidth: theme.breakpoints.values.xl,
    margin: '0 auto',
    [theme.breakpoints.up('md')]: {
      gridTemplateRows: 'auto',
      gridTemplateAreas: `
        "stepper step docs"
      `,
      gridTemplateColumns: '200px calc(100% - 200px - 200px) 200px',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: '224px calc(100% - 224px - 300px) 300px',
    },
    // Since this component is used for tutorials, we want to make sure the content is readable
    '& p': {
      maxWidth: '80ch',
    },
  },
}));

export function TutorialWizard({
  title,
  onClose,
  children,
}: TutorialWizardProps) {
  const classes = useStyles();
  return (
    <Box className={classes.wizard}>
      <Header title={title} onClose={onClose} />
      <Box className={classes.grid}>{children}</Box>
    </Box>
  );
}

TutorialWizard.StepperContext = StepperContext;
TutorialWizard.Stepper = Stepper;
TutorialWizard.Step = Step;
TutorialWizard.StepTitle = StepTitle;
